export default function path(value: string) {
	return (target: any) => Object.defineProperty(target, 'path', {
		configurable: false,
		enumerable: false,
		value,
		writable: false,
	});
}
